var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video-js vjs-16-9",attrs:{"id":"my-player","controls":"","preload":"auto","poster":_vm.video.image ? _vm.video.image : '/images/social-cover-image-v3.jpg',"data-setup":"{}"}})
}
var staticRenderFns = []

export { render, staticRenderFns }